module.exports = __webpack_public_path__ + "img/icono_247_acmi.148e58c5.png";